import { DateInput } from "components/ui";
import { Input, InputAffix, NativeSelect } from "components/ui";

export default function BulkFieldInput({
  field,
  value,
  onChange,
  excludeValue,
  onExcludeChange,
  softwareSettings,
  translate,
  editableTranslate,
  disabled = false,
}) {
  if (field.available_values) {
    return (
      <NativeSelect value={value ?? ''} onChange={e => onChange(e.target.value)} disabled={disabled} data-testid={`bulk-value-${field.key}`}>
        <option value="">{translate('form.select_placeholder')}</option>
        {Object.entries(field.available_values).map(([v, translationKey]) => (
          <option key={v} value={v}>{translate(translationKey)}</option>
        ))}
      </NativeSelect>
    );
  }

  if (field.key === 'working_hours') {
    return (
      <InputAffix
        disabled={disabled}
        suffix={softwareSettings?.working_hours_type === 'hours'
          ? editableTranslate('general_settings.working_hours_type.hours')
          : editableTranslate('general_settings.working_hours_type.percentage')}
      >
        <Input type="text" value={value ?? ''} onChange={e => onChange(e.target.value)} disabled={disabled} maxLength={24} data-testid={`bulk-value-${field.key}`} />
      </InputAffix>
    );
  }

  if (['annual_compensation', 'individual_ceiling'].includes(field.key)) {
    return (
      <InputAffix prefix="€" disabled={disabled}>
        <Input type="text" value={value ?? ''} onChange={e => onChange(e.target.value)} disabled={disabled} maxLength={24} data-testid={`bulk-value-${field.key}`} />
      </InputAffix>
    );
  }

  if (field.key === 'missing_months' || field.key === 'missing_days') {
    return (
      <InputAffix
        disabled={disabled}
        suffix={field.key === 'missing_months' ? editableTranslate('form.months', 'Monate') : editableTranslate('form.days', 'Tage')}
      >
        <Input type="text" value={value ?? ''} onChange={e => onChange(e.target.value)} disabled={disabled} maxLength={7} data-testid={`bulk-value-${field.key}`} />
      </InputAffix>
    );
  }

  if (field.key === 'exclude_from_payout_reason') {
    const excluded = excludeValue === 'true' || excludeValue === true;
    return (
      <div className="d-flex select-with-input">
        <NativeSelect className="w-auto" value={excluded ? 'true' : 'false'} onChange={e => onExcludeChange(e.target.value)} disabled={disabled} data-testid={`bulk-exclude-${field.key}`}>
          <option value="true">{translate('form.yes', 'Ja')}</option>
          <option value="false">{translate('form.no', 'nein')}</option>
        </NativeSelect>
        <Input type="text" value={value ?? ''} onChange={e => onChange(e.target.value)} readOnly={disabled || !excluded} maxLength={50} data-testid={`bulk-value-${field.key}`} />
      </div>
    );
  }

  if (field.key.includes('date')) {
    return <DateInput value={value ?? ''} onChange={e => onChange(e.target.value)} disabled={disabled} testId={`bulk-value-${field.key}`} />;
  }

  return (
    <Input
      type="text"
      value={value ?? ''}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      autoComplete="on"
      maxLength={255}
      data-testid={`bulk-value-${field.key}`}
    />
  );
}
